import { useTranslate } from "@similarweb/i18n-provider";
import { Alerts } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { industryTransitionKeys } from "../../utils/i18n";

import { SuccessFollowUpNoticeBox } from "./styles";

const BELL_ICON_SIZE = 24;

/** The success screen's CRM callout: a follow-up task, so a neutral panel with a bell — not blue, not a notice. */
export const EnrollFollowUpNotice = () => {
    const { translate } = useTranslate();

    return (
        <SuccessFollowUpNoticeBox data-automation="industry-transition-impact-report-success-crm-notice">
            <Alerts
                size={BELL_ICON_SIZE}
                color={colorsPalettes.carbon[200]}
            />
            <Text
                fontVariant="body2"
                color={colorsPalettes.carbon[400]}
            >
                {translate(industryTransitionKeys.successCrmNotice)}
            </Text>
        </SuccessFollowUpNoticeBox>
    );
};
